export const HTML_EDITOR = {
  GET_DATA: "/print-template/getPrintableData",
  SUB_LETTER_TYPES: "/template-Mapping/letter",
  JOIN_TEMPLATEDATA: "?join=letter&join=header&join=content&join=footer",
};
